import type { ReportField, SortField } from "../../../../../../../../api/types/svTypes";
import { AreaItemType, Ordering, SortType } from "../../../../../../../../api/types/svTypes";
import { isCustomColumn, isDimensionBased, isMeasure } from "../../../../utilities/fieldsHelper";

export type SortingFieldModel = readonly SortingFieldItem[];
interface SortingFieldItem {
  field: string;
  sort: "asc" | "desc" | null | undefined;
}

export const rebuildSortingFields = (
  newSorting: SortingFieldModel,
  fields: ReportField[],
  currentSorts: SortField[]
) => {
  const currentSortCopy = structuredClone(currentSorts.filter((s) => s.config.isGroupField === true));

  newSorting.forEach((sortItem) => {
    const field = fields.find((f) => f.config.guid === sortItem.field);
    if (isDimensionBased(field) || isMeasure(field) || isCustomColumn(field)) {
      const currentSort = currentSortCopy.find((s) => s.config.id === field.config.guid);
      const ordering = getOrdering(sortItem.sort);

      if (currentSort) {
        currentSort.config.ordering = ordering;
      } else {
        const config = {
          name: field.meta.name,
          ordering,
          caption: field.config.customLabel || field.meta.caption,
          isGroupField: false as const,
          id: field.config.guid,
          type: getSortType(field),
        };
        if (isDimensionBased(field)) {
          currentSortCopy.push({
            meta: field.meta,
            config,
            areaItemType: AreaItemType.SORTS,
          });
        } else if (isCustomColumn(field)) {
          currentSortCopy.push({
            meta: field.meta,
            config,
            areaItemType: AreaItemType.SORTS,
          });
        } else {
          currentSortCopy.push({
            meta: field.meta,
            config,
            areaItemType: AreaItemType.SORTS,
          });
        }
      }
    }
  });

  return currentSortCopy;
};

const getSortType = (field: ReportField): SortType => {
  if (isDimensionBased(field)) {
    return SortType.Dimension;
  }
  if (isCustomColumn(field)) {
    return SortType.Custom;
  }
  if (isMeasure(field)) {
    return SortType.Measure;
  }
  return SortType.Dimension;
};

const getOrdering = (sort: "asc" | "desc" | null | undefined): Ordering => {
  return sort === "asc" ? Ordering.Ascending : Ordering.Descending;
};
